<template>
  <div class="chatPage" :style="setStyle">
    <div class="key_container">
      <div class="key_div">
        <div class="keyword">
          <label class="key_lb">关键字：{{ keyInfo.keyword }}</label>
          <img
            src="../../../static/talks/t_keytip.png"
            style="width: 14px; height: 14px"
          />
        </div>
        <div class="otherInfo">
          <label class="brow_lb">当前浏览：</label
          ><label class="url_lb">{{ keyInfo.brower }}</label>
          <label class="site_lb">所属站点：{{ keyInfo.site }}</label>
        </div>
        <div class="history_div">
          <img
            class="history_img"
            src="../../../static/talks/t_history.png"
            style="width: 18px; height: 18px"
          />
          <label class="history_lb">查看历史消息</label>
        </div>
      </div>
    </div>

    <div class="taleBox" ref="scrollNode">
      <chatList
        :list="taleList"
        @click="bindEvent"
        @loadHistory="loadHistoryHandler"
        :config="chatListConfig"
      />
    </div>
    <div class="toolBox">
      <tools
        :tools="toolConfig"
        class="tools"
        @emoji="bindEmoji"
        @clickSend="toolSend"
      >
        <slot name="tools" slot="tools" />
      </tools>
      <EnterBox @submit="enter" v-model="msg" />
    </div>
    <bottom-tools :user="userData"></bottom-tools>
  </div>
</template>

<script>
import EnterBox from "./enterBox.vue";
import chatList from "./chatList.vue";
import tools from "./tools.vue";
import bottomTools from "./bottomTools.vue";
export default {
  name: "JwChat",
  components: {
    EnterBox,
    chatList,
    tools,
    bottomTools,
  },
  props: {
    taleList: {
      type: Array,
      default: () => [],
    },
    userInfo: {
      type: Object,
    },
    scroll: {
      type: Number,
      default: -1,
    },
    height: {
      default: "500px",
    },
    width: {
      default: "550px",
    },
    value: {
      default: "",
    },
    scrollType: {
      default: "",
    },
    toolConfig: {
      type: Object,
      default: () => ({
        show: ["file", "video", "img"],
        callback: Function,
      }),
    },
    config: {},
  },
  data() {
    return {
      msg: "",
      scrollToButton: false,
      keyInfo: {
        keyword: "大便上有白色粘稠物是癌症吗",
        brower: "http://wap.cdchnkyy.net/",
        site: "A",
      },
      userData: {},
    };
  },
  watch: {
    userInfo(newVal, oldVal) {
      console.log("chat index watch userInfo new = ", newVal);
      console.log("chat index watch userInfo old = ", oldVal);
      this.userData = newVal;
      console.log("chat index watch userInfo userData = ", this.userData);
    },

    scroll(newVal) {
      if (typeof newVal === "number") {
        this.setScroll(newVal);
      }
    },
    value: {
      handler() {
        this.msg = this.value;
      },
      immediate: true,
    },
    msg: {
      handler() {
        this.$emit("input", this.msg);
      },
      immediate: true,
    },
    scrollToButton(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.scrollToButton = false;
        }, 0);
      }
    },
  },
  computed: {
    setStyle() {
      let height = this.height;
      let width = this.width;
      if (`${height}`.match(/\d$/)) {
        height += "px";
      }
      if (`${width}`.match(/\d$/)) {
        width += "px";
      }
      const style = {
        height,
        width,
      };
      return style;
    },
    talkHeight() {
      let height = this.height;
      if (`${height}`.match(/\d$/)) {
        height -= 140;
      } else height = `calc(${height} - 140px)`;
      return height;
    },
    chatListConfig() {
      const {
        width,
        talkHeight: height,
        scrollToButton,
        scrollType,
        config: { historyConfig = {} } = {},
      } = this;
      return {
        width,
        height,
        scrollToButton,
        scrollType,
        historyConfig,
      };
    },
  },

  mounted() {
    console.log("chat index mounted");
    // let siteObj = JSON.parse(sessionStorage.getItem('siteObj'))
    // this.keyInfo.site = siteObj.webId
  },

  methods: {
    bindEvent(play) {
      this.$emit("clickTalk", play);
    },
    bindEmoji(emoji) {
      this.msg += emoji;
    },
    enter(msg) {
      this.$emit("enter", msg);
    },
    toolSend() {
      this.$emit("enter", this.msg);
      this.$nextTick(() => {
        this.msg = "";
      });
    },
    toButton() {
      this.scrollToButton = !this.scrollToButton;
    },
    loadHistoryHandler() {
      const { historyConfig: { callback = null } = {} } = this.chatListConfig;
      callback && callback();
    },
  },
};
</script>
<style lang="scss" scoped>
.chatPage {
  margin: 0 auto;
  position: relative;
  // background: cyan;
  overflow: scroll;
  width: 100%;
  height: 680px;
}

.chatPage::-webkit-scrollbar {
  display: none;
}

.key_container {
  width: 100%;
  height: 120px;
  // background-color: coral;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.key_div {
  width: 60%;
  height: 84px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin-top: 10px;
}

.keyword {
  width: 100%;
  height: 33px;
  // background-color: #7A88FF;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  // margin-top: 3px;
}

.otherInfo {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 30px;
  // background-color: goldenrod;
}

.history_div {
  width: 100%;
  height: 27px;
  // background-color: yellowgreen;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.history_lb {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  margin-left: 10px;
}

.brow_lb {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  // margin-right: 10px;
  margin-left: 10px;
}

.url_lb {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  text-decoration: underline;
  text-decoration-color: rgba(0, 0, 0, 0.65);
}

.site_lb {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  margin-left: 30px;
}

.key_lb {
  width: 90%;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  // background-color: coral;
  text-align: left;
}

.taleBox {
  height: calc(100% - 290px);
  min-height: 200px;
  overflow: scroll;
  width: 700px;
  position: relative;
}
.taleBox::-webkit-scrollbar {
  display: none;
}

.toolBox {
  height: 120px;
  // margin-top: 10px;
}

.bottomBox {
  width: 100%;
  // height: 150px;
  // background-color: #FC427B;
}
</style>
